import angular from 'angular';

let whenScrolledModule = angular.module('shared.components.whenScrolled',[])
  .directive('whenScrolled', whenScrolled);

function whenScrolled(){

}

whenScrolled.$inject = [];
export default whenScrolledModule;



/** WEBPACK FOOTER **
 ** C:/Bitnami/wampstack-7.1.31-0/apache2/htdocs/toning/B2C/www/components/shared/components/when-scrolled/when-scrolled.js
 **/